function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M150 300C232.843 300 300 232.843 300 150C300 67.1573 232.843 0 150 0C67.1573 0 0 67.1573 0 150C0 232.843 67.1573 300 150 300Z",
  fill: "#10BA97"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M53 149.5C53 142.186 54.396 135.795 57.1881 130.327C60.0482 124.791 64.1001 120.519 69.3437 117.511C74.6554 114.504 80.8864 113 88.0368 113C93.6209 113 98.6261 114.094 103.053 116.281C107.479 118.468 111.054 121.544 113.778 125.508C116.502 129.473 118.136 134.052 118.681 139.247H103.359C102.474 135.146 100.601 131.934 97.7409 129.61C94.9488 127.217 91.4417 126.021 87.2196 126.021C81.4993 126.021 76.9707 128.174 73.6339 132.48C70.2971 136.787 68.6287 142.46 68.6287 149.5C68.6287 156.472 70.2971 162.145 73.6339 166.52C76.9707 170.826 81.4993 172.979 87.2196 172.979C91.4417 172.979 94.9488 171.817 97.7409 169.493C100.601 167.101 102.474 163.854 103.359 159.753H118.681C118.136 164.948 116.502 169.527 113.778 173.492C111.054 177.456 107.479 180.532 103.053 182.719C98.6261 184.906 93.6209 186 88.0368 186C80.8864 186 74.6554 184.496 69.3437 181.489C64.1001 178.481 60.0482 174.243 57.1881 168.775C54.396 163.239 53 156.814 53 149.5Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M127.583 113.615H142.905V142.426H171.303V113.615H186.625L186.625 185.385H171.303V155.754H142.905V185.385H127.583L127.583 113.615Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M198.808 113.615L246 113.615V126.841L214.13 126.841V143.656H240.28V156.267H214.13L214.13 185.385H198.808L198.808 113.615Z",
  fill: "white"
});

var SvgChf = function SvgChf(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChf, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/CHF.3f62e7fb.svg";
export { ForwardRef as ReactComponent };